import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import CityDropdown from "../HomeComonents/CityDropdown";
import ReCAPTCHA from "react-google-recaptcha";
import toast from "react-hot-toast";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@mui/material";

const MemberShipForm = () => {
    const [formData, setFormData] = useState({
      titleid: '',
  fullname: "",
  phoneNo: "",
  email: "",
  membershipCategory: "0",
  businessName: "",
  businessAddressLine1: "",
  businessAddressLine2: "",
  city: "",
  postcode: "",
  countryCode: "+44",
  consent: false,
  reCaptcha: "",
});

const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
const navigate = useNavigate();

// Framer motion animation settings for heading
const headingVariants = {
  hidden: { opacity: 0, x: 50 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.1,
      type: "spring",
      stiffness: 120,
    },
  }),
};

const headingText = "Membership Form";

// Handle input change for all form fields
const handleInputChange = (e) => {
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
  setErrors((prev) => ({ ...prev, [name]: "" }));
};

// Handle membership category checkbox change
const handleCheckBoxMemberChange = (e) => {
  const { value } = e.target;
  setFormData((prev) => ({
    ...prev,
    membershipCategory: value,
  }));
  setErrors((prev) => ({ ...prev, membershipCategory: "" }));
};

// Function to validate UK postcode format
const isValidUKPostcode = (postcode) => {
  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|GIR 0AA)$/i;
  return ukPostcodeRegex.test(postcode);
};

// Form validation function
const validateForm = () => {
  const newErrors = {};
  if (!formData.fullname) newErrors.fullname = "Full Name is required.";
  if (!formData.titleid) newErrors.titleid = "Title  is required";
  if (!formData.phoneNo) newErrors.phoneNo = "Phone No is required.";
  if (!formData.email) newErrors.email = "Email is required.";
  if (!formData.businessName) newErrors.businessName = "Business Name is required.";
  if (!formData.businessAddressLine1) newErrors.businessAddressLine1 = "Business Address Line 1 is required.";
  if (!formData.city) newErrors.city = "City is required.";
  if (!formData.postcode) {
    newErrors.postcode = "Postcode is required.";
  } else if (!isValidUKPostcode(formData.postcode)) {
    newErrors.postcode = "Please enter a valid UK postcode.";
  }
  if (!formData.consent) newErrors.consent = "Please accept the Privacy Policy.";
  // if (!formData.reCaptcha) newErrors.reCaptcha = "Please verify that you are not a robot.";

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const handleCheckboxChange = (e)=>{
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value, // Handle checkbox input
   
  }));
  setErrors((prev) => ({ ...prev, [name]: "" }));
}

// Handle reCaptcha validation
const handleReCaptcha = (value) => {
  setFormData((prev) => ({ ...prev, reCaptcha: value }));
};


const trimFormData = (data) => {
  const trimmedData = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];
    // Check if the value is a string, then trim it
    trimmedData[key] = typeof value === "string" ? value.trim() : value;
  });
  return trimmedData;
};

// Handle form submission
const handleSubmit = async (e) => {
  e.preventDefault();
  window.grecaptcha.reset();

  if (!validateForm()) return;

  let toastId;
  try {
    toastId = toast.loading(<b>Saving...</b>);
    const trimmedFormData = trimFormData(formData); // Trim all form data fields

    const response = await axios.post(
      "https://msbassociationuk.org/prod/api/msb/savemembershipdetails",
      trimmedFormData
    );

    if (response.data.response && response.data.responseCode === "00") {
      toast.dismiss(toastId);
      toast.success(<b>Form submitted successfully!</b>);
      setTimeout(() => navigate("/member-success"), 500);

      // Reset form after submission
      setFormData({
        titleid: '',
        fullname: "",
        phoneNo: "",
        email: "",
        membershipCategory: "0",
        businessName: "",
        businessAddressLine1: "",
        businessAddressLine2: "",
        city: "",
        postcode: "",
        countryCode: "+44",
        consent: false,
        reCaptcha: "",
      });
    } else {
      toast.dismiss(toastId);
     
      toast.error(response.data.data || "Something went wrong. Please try again.");
    }
  } catch (error) {
    toast.dismiss(toastId);
    toast.error(error.response?.data?.data || "Something went wrong. Please try again.");
  }
};

  return (
    <div>
      <section className="job_apply_section section_space">
        <div style={{maxWidth: '850px', margin: '0 auto'}}>
          <div className="job_apply_form" style={{background: '#efefef'}}>
            <div className="heading_block">
              <h3 className="heading_text">
                {headingText.split("").map((char, i) => (
                  <motion.span
                    key={`${char}-${i}`}
                    custom={i}
                    initial="hidden"
                    animate="visible"
                    variants={headingVariants}
                  >
                    {char}
                  </motion.span>
                ))}
              </h3>
              <p className="heading_description mb-0">
                Please fill out the form below to apply for membership with the
                MSB Association.
              </p>
            </div>
            <form onSubmit={handleSubmit}>
              {/* Business Information Section */}
              <div className="card mb-4 p-3 pb-3">
                <h5 className="card-header mb-4">Business Information</h5>
                <div className="card-body">
                  <div className="row">
                  <div className=" mt-3">
      <FormControl component="fieldset" className="form-group w-100 ">
        <label component="legend" className="input_title ">
        Select Your Membership Type <sup>*</sup>
        </label>
        <FormGroup>
        <div className="row mt-2 mb-2">
        <div className="col-6">
         <FormControlLabel
            control={
              <Checkbox
                checked={formData.membershipCategory === "0"}
                onChange={handleCheckBoxMemberChange}
                name="membershipCategory"
                id="msbOption"
                value="0"
              />
            }
            label="MSB Member"
          />
         </div>
          <div className="col-6">
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.membershipCategory === "1"}
                onChange={handleCheckBoxMemberChange}
                name="membershipCategory"
                id="affiliateOption"
                value="1"
              />
            }
            label="Affiliate Member"
          />
          </div>
        </div>
        </FormGroup>
      </FormControl>
    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="input_title" htmlFor="businessName">Business Name<sup>*</sup></label>
                        <input
                          id="businessName"
                          className={`form-control ${errors.businessName ? "bg-danger" : ""}`}
                          type="text"
                          name="businessName"
                          placeholder="Enter your Business Name"
                          value={formData.businessName}
                          onChange={handleInputChange}
                        />
                        {errors.businessName && (
                          <span className="text-danger">{errors.businessName}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label className="input_title" htmlFor="businessAddressLine1">Address Line 1<sup>*</sup></label>
                        <input
                          id="businessAddressLine1"
                          className={`form-control ${
                            errors.businessAddressLine1 ? "bg-danger" : ""
                          }`}
                          type="text"
                          name="businessAddressLine1"
                          placeholder="Enter Address Line 1"
                          value={formData.businessAddressLine1}
                          onChange={handleInputChange}
                        />
                        {errors.businessAddressLine1 && (
                          <span className="text-danger">{errors.businessAddressLine1}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label className="input_title" htmlFor="businessAddressLine2">Address Line 2</label>
                        <input
                          id="businessAddressLine2"
                          className={`form-control ${
                            errors.businessAddressLine2 ? "bg-danger" : ""
                          }`}
                          type="text"
                          name="businessAddressLine2"
                          placeholder="Enter Address Line 2"
                          value={formData.businessAddressLine2}
                          onChange={handleInputChange}
                        />
                         {errors.businessAddressLine2 && (
                          <span className="text-danger">{errors.businessAddressLine2}</span>
                        )}
                      </div>
                    </div> 

                    <CityDropdown formData={formData} setFormData={setFormData} errors={errors} />
                    <div className="col-md-6 mt-3">
                      <div className="form-group">
                        <label className="input_title" htmlFor="postcode">Postcode<sup>*</sup></label>
                        <input
                          id="postcode"
                          className={`form-control ${errors.postcode ? "bg-danger" : ""}`}
                          type="text"
                          name="postcode"
                          placeholder="Enter Postcode"
                          value={formData.postcode}
                          onChange={handleInputChange}
                        />
                        {errors.postcode && (
                          <span className="text-danger">{errors.postcode}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Personal Information Section */}
              <div className="card mb-4 p-3 pb-3">
                <h5 className="card-header">Personal Information</h5>
                <div className="card-body mt-3">
                  <div className="row">
                  <div className="col-md-2 col-12">
                      <div className="form-group">
                        <label className="input_title mt-3" htmlFor="title">Title<sup>*</sup></label>
                        <select
  id="titleid"
  className={`form-control p-3 ${errors.titleid ? "bg-danger" : ""}`}
  name="titleid"
  value={formData.titleid}
  onChange={handleInputChange}
>
  <option value="">Select Title</option>
  {[
    { label: "Mr.", value: 1 },
    { label: "Mrs.", value: 2 },
    { label: "Miss", value: 3 },
    { label: "Dr.", value: 4 },
  ].map((title) => (
    <option key={title.value} value={title.value}>
      {title.label}
    </option>
  ))}
</select>

                        {errors.titleid && <span className="text-danger">{errors.titleid}</span>}
                      </div>
                    </div>
                    <div className="col-md-10">
                      <div className="form-group">
                        <label className="input_title mt-3" htmlFor="name">Full Name<sup>*</sup></label>
                        <input
                          id="fullname"
                          className={`form-control ${errors.fullname ? "bg-danger" : ""}`}
                          type="text"
                          name="fullname"
                          placeholder="Enter your Full Name"
                          value={formData.fullname}
                          onChange={handleInputChange}
                        />
                        {errors.fullname && <span className="text-danger">{errors.fullname}</span>}
                      </div>
                    </div>
                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label className="input_title" htmlFor="phone">Phone<sup>*</sup></label>
                        <div className="input-group">
                          <select
                            id="countryCode"
                            className="form-control p-3"
                            name="countryCode"
                            style={{maxWidth: '80px'}}
                            value={formData.countryCode}
                            onChange={handleInputChange}
                          >
                            <option value="+44">+44</option>
                          </select>
                          <input
                            className={`form-control ${
                              errors.phoneNo ? "bg-danger" : ""
                            }`}
                            type="text"
                            name="phoneNo"
                            placeholder="Enter Phone / Mobile Number"
                            value={formData.phoneNo}
                            onChange={handleInputChange}
                          />
                        </div>
                        {errors.phoneNo && <span className="text-danger">{errors.phoneNo}</span>}
                      </div>
                    </div>
                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label className="input_title" htmlFor="email">Email Address<sup>*</sup></label>
                        <input
                          id="email"
                          className={`form-control ${errors.email ? "bg-danger" : ""}`}
                          type="email"
                          name="email"
                          placeholder="Enter your Email Address"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        {errors.email && <span className="text-danger">{errors.email}</span>}
                      </div>
                    </div>
                    <div className="col-md-12 mt-3">
           
                    <ReCAPTCHA
                      sitekey="6LfmsZoqAAAAAPQgbaeEuX7w8IZxz7Ncqgs2i0hY"
                      onChange={handleReCaptcha}
                      onErrored={() =>
                        setErrors((prev) => ({ ...prev, captcha: "Captcha verification failed." }))
                      }
                    />
                    {errors.reCaptcha && <span className="text-danger">{errors.reCaptcha}</span>}
       
                 </div>
                    <div className="form-group mb-4 mt-4">
                <div className="form-check ">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="consent"
                    name="consent"
                    checked={formData.consent}
                    onChange={handleCheckboxChange}
                  />
                  <label className="form-check-label" htmlFor="consent">
                    By submitting this membership form, I hereby consent to the collection, use,
                    and processing of my personal information as outlined in the{" "}
                    <NavLink to="/privacy-policy" target="_blank" rel="noopener noreferrer">
                      Privacy Policy
                    </NavLink>
                    .
                  </label>
                </div>
                {errors.consent && (
                  <div className="text-danger mt-2">{errors.consent}</div>
                )}
              </div>
      
                    <div className="col-md-12">
                    <div className="text-center mt-4">
                <button type="submit" className="btn btn-primary btn-lg">
                  Submit
                </button>
              </div>
                    </div>
                  </div>
                </div>
              </div>
           
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MemberShipForm;
